
// src/actions/device-orientation.js

export const CHANGE_DEVICE_ORIENTATION = "CHANGE_DEVICE_ORIENTATION"

export function changeDeviceOrientation() {
  return {
    type: CHANGE_DEVICE_ORIENTATION,
  }
}




// WEBPACK FOOTER //
// ./src/actions/device-orientation.js